import { gql, useQuery } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';

function useCategoryProductsBySlug(
  fabricId,
  setDoubleGrid,
  isMobile,
  saveDoubleGrid,
  orderField,
  quickShip
) {
  const match = useRouteMatch();
  const slug = match.params.categorySlug.toLowerCase();

  const { loading, error, data } = useQuery(CATEGORY_PRODUCTS_BY_SLUG, {
    fetchPolicy: 'network-only',
    variables: {
      slug: slug,
      fabric_id: fabricId,
      orderField,
      quickShip
    },
    onCompleted(data) {
      if (data.categoryProductsBySlug?.subcategories?.length == 1) {
        setDoubleGrid(false);
        return;
      }

      const layout = data.categoryProductsBySlug.layout;

      if (
        (layout === 'two_columns' && !isMobile && !saveDoubleGrid) ||
        (layout === '' && !isMobile && !saveDoubleGrid)
      ) {
        setDoubleGrid(true);
      }

      if (layout === 'one_column' && !isMobile && !saveDoubleGrid) {
        setDoubleGrid(false);
      }
    }
  });

  return { loading, error, data };
}

export default useCategoryProductsBySlug;

const CATEGORY_PRODUCTS_BY_SLUG = gql`
  query categoryProductsBySlug(
    $slug: String!
    $fabric_id: ID
    $orderField: String
    $quickShip: Boolean
  ) {
    categoryProductsBySlug(
      slug: $slug
      fabric_id: $fabric_id
      orderField: $orderField
      quickShip: $quickShip
    ) {
      id
      slug
      name
      title
      seo_title
      seo_description
      description
      hero_image
      layout
      featured_products_title
      default_fabric {
        id
        is_available_on_pdp
        slug
        name
        image
        collaborator {
          id
          name
        }
      }
      subcategories {
        id
        name
        avg_rating
        total_reviews
        products {
          id
          name
          sku
          slug
          url
          total_pdp_fabrics
          availableWallpaperTypes
          price
          is_purchasable
          is_quick_ship
          badge_treatment {
            id
            name
          }
          full_price
          traditional_retail_price
          fabric {
            id
            is_available_on_pdp
            name
            collaborator {
              id
              name
            }
          }
          frame {
            subcategories {
              id
              name
              category {
                id
                name
              }
            }
            primarySubcategory {
              id
              category_id
              name
            }
            id
            name
            wallpaper_type
            has_set_of_two
            is_final_sale
            orientation
            type {
              id
              name
            }
            size {
              id
              is_available_on_pdp
              name
            }
            legs {
              id
              name
            }
            description
          }
          images {
            id
            name
            width
            height
            path
          }
        }
      }

      # Featured Products
      featuredProducts {
        id
        name
        sku
        slug
        url
        total_pdp_fabrics
        availableWallpaperTypes
        price
        allow_individual_purchases
        is_purchasable
        badge_treatment {
          id
          name
        }
        full_price
        traditional_retail_price
        fabric {
          id
          is_available_on_pdp
          name
          collaborator {
            id
            name
          }
        }
        bundle_products {
          id
          quantity
          product {
            id
            slug
            sku
            name
            price
            frame {
              id
              name
              size {
                id
                is_available_on_pdp
                name
              }
              subcategories {
                id
                name
                category {
                  id
                  name
                }
              }
              primarySubcategory {
                id
                category_id
                name
              }
            }
            fabric {
              id
              name
              is_available_on_pdp
              collaborator {
                id
                name
              }
            }
            images {
              id
              name
              path
            }
          }
        }
        frame {
          id
          name
          wallpaper_type
          has_set_of_two
          is_final_sale
          orientation
          primarySubcategory {
            id
            category_id
            name
          }
          subcategories {
            id
            name
            total_reviews
            avg_rating
            category {
              id
              name
            }
          }
          size {
            id
            is_available_on_pdp
            name
          }
          legs {
            id
            name
          }
          description
        }
        images {
          id
          name
          width
          height
          path
        }
      }
    }
  }
`;
